import { useNavigate } from "react-router-dom";
import { useLoginCompany, useSelectCompanyLogin } from "http-hooks/company/useCompanyAuth";
import { useCompanyAuthStore } from "store/companyAuth";

const useCompanyAuth = () => {
  const navigate = useNavigate();
  
  // Store selectors
  const companyId = useCompanyAuthStore((state) => state.companyId);
  const companyName = useCompanyAuthStore((state) => state.companyName);
  const token = useCompanyAuthStore((state) => state.token);
  const role = useCompanyAuthStore((state) => state.role);
  const maxusers = useCompanyAuthStore((state) => state.maxusers);
  const acctype = useCompanyAuthStore((state) => state.acctype);
  const subscription_type = useCompanyAuthStore((state) => state.subscription_type);
  const plantype = useCompanyAuthStore((state) => state.plantype);
  const isCompanyAdmin = useCompanyAuthStore((state) => state.isCompanyAdmin);
  const isAuthenticated = useCompanyAuthStore((state) => state.isCompanyAdminAuthenticated());
  const clearCompanyAuthData = useCompanyAuthStore((state) => state.clearCompanyAuthData);

  // Login mutations
  const loginMutation = useLoginCompany();
  const selectCompanyMutation = useSelectCompanyLogin();

  // Auth actions
  const login = (credentials) => {
    return loginMutation.mutateAsync(credentials);
  };

  const selectCompany = (data) => {
    return selectCompanyMutation.mutateAsync(data);
  };

  const logout = () => {
    clearCompanyAuthData();
    navigate("/company-login");
  };

  return {
    // Auth state
    companyId,
    companyName,
    token,
    role,
    maxusers,
    acctype,
    subscription_type,
    plantype,
    isCompanyAdmin,
    isAuthenticated,
    
    // Auth actions
    login,
    selectCompany,
    logout,
    
    // Login mutation state
    isLoggingIn: loginMutation.isPending,
    loginError: loginMutation.error,
    isSelecting: selectCompanyMutation.isPending,
    selectError: selectCompanyMutation.error,
  };
};

export default useCompanyAuth;

